import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './css/85bb65.css';
import API from './API';
import { R } from './routes';

import store from './store';
import Me from './Me';
import { Provider as ReduxProvider } from 'react-redux';
import { TraksProvider, TraksConsumer } from './traks.js';
import PotentialFatalErrorPage from './p/PotentialFatalErrorPage';
import { TickerTapeInjectCSS } from './c/TickerTape';

/* not-too-pretty solution for making the current language globally available.
 * the alternative would be to somehow support via non-React stuff in traks?
 * but yeah, this non-Component solves the problem :) */
const SetLangGlobal = (props) => {
	window.GLOBAL_LANG = props.lang;
	return null;
};

/* ...the browser inside iOS app lacks console.warn? */
if (console.warn === undefined) console.warn = console.log;

const start = () => {
	TickerTapeInjectCSS();
	API.get("/a/whoami", (me) => {
		Me.set(me);
		ReactDOM.render(
			<ReduxProvider store={store}>
				<TraksProvider>
					<TraksConsumer><SetLangGlobal/></TraksConsumer>
					<PotentialFatalErrorPage>
						{R.component()}
					</PotentialFatalErrorPage>
				</TraksProvider>
			</ReduxProvider>,
			document.getElementById('root')
		);
	});
};
if (IS_AKTIEDYSTEN_DK) {
	import('./css/aktiedysten_dk.css').then(start);
} else if (IS_AKTIEKAMPEN_SE) {
	import('./css/aktiekampen_se.css').then(start);
} else if (IS_INVESTSPIEL_DE) {
	import('./css/investspiel_de.css').then(start);
} else if (IS_TRADERR_COM) {
	import('./css/traderr_com.css').then(start);
}



// WEBPACK FOOTER //
// ./src/index.js